<template>
  <layout-auth>
    <v-toolbar flat color="grey lighten-3" height="50px">
      <v-container>
        <a @click="$router.push('/gestion-de-usuarios')" class="sub-nav"
          >Área de Usuario</a
        >
        <a
          @click="$router.push('/gestion-de-usuarios/add')"
          style="font-weight: bold; color: #222222 !important"
          class="sub-nav"
        >
          {{ $t("users.userManagement") }}</a
        >
      </v-container>
    </v-toolbar>
    <v-form ref="createUserForm" v-model="validForm">
      <v-container class="py-10">
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("users.userManagement") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("users.createNewUser") }}
            </h2>
            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("users.addUserSubtitle") }}
            </h3>
          </v-col>
        </v-row>
        <v-row class="py-10">
          <v-col cols="12" sm="12" md="6" lg="4">
            <label>{{ $t("users.nameAlias") }}</label>
            <v-text-field
              dense
              outlined
              v-model="form.alias"
              :color="entityConfig.primaryColor"
              counter
              maxlength="9"
              minlength="8"
              :rules="[required, alpheNumeric, minAlias, maxAlias, minAlias]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="4">
            <label>{{ $t("users.email") }}</label>
            <v-text-field
              dense
              outlined
              v-model="form.email"
              :color="entityConfig.primaryColor"
              hint="hasta 50 caracteres"
              maxlength="50"
              :rules="emailRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pb-10">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              depressed
              :disabled="!validForm"
              @click="confirmCreate"
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end v-btn-width-default"
              >{{ $t("users.save") }}</v-btn
            >
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </v-form>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";

export default {
  components: {
    "layout-auth": LayoutAuth,
  },
  data() {
    return {
      validForm: false,
      form: {
        alias: "",
        email: "",
      },
      emailRules: [
        (v) => !!v || "Email es requerido",
        (v) => /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) || "Email no valido",
      ],
      alpheNumeric: (v) =>
        /^[a-zA-Z0-9_ ]*$/.test(v) || "Solo caracteres alfanumericos",
      required: (value) => !!value || "Este campo es requerido..",
      maxAlias: (v) => v.length <= 9 || "9 caracteres Maximo",
      minAlias: (v) => v.length >= 8 || "8 caracteres minimo",

      entityConfig: {},
    };
  },
  mounted() {
    let newUser = JSON.parse(sessionStorage.getItem("userConfirm"));
    if (newUser) {
      this.form = newUser;
    }
    this.entityConfig = this.$store.state.entityConfig.config;
  },
  methods: {
    confirmCreate() {
      sessionStorage.setItem("userConfirm", JSON.stringify(this.form));
      this.$router.push("/gestion-de-usuarios/confirm");
    },
  },
};
</script>
